import { BCNotificationProps } from '../entities/BCNotificationProps';

// Must be inline css
const titleStyles: React.CSSProperties = { fontSize: '12px', margin: '5px 0' };
const descriptionStyles: React.CSSProperties = { fontSize: '12px', margin: '0' };
const buttonStyles: React.CSSProperties = { float: 'right', marginTop: '12px' };

const Notification: React.FC<BCNotificationProps> = props => {
	return (
		<div>
			{props.message && <h6 style={titleStyles}>{props.message}</h6>}
			{props.description && <p style={descriptionStyles}>{props.description}</p>}
			{props.btn && <div style={buttonStyles}>{props.btn}</div>}
		</div>
	);
};

export { Notification };
